module.exports = __webpack_public_path__ + "static/media/Vector.d0f2258b.svg";